import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <>
      <motion.nav initial={{
      y: -100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 border-b border-white/5 ${scrolled ? 'bg-richBlack/80 backdrop-blur-md py-3' : 'bg-transparent py-4'}`} data-id="element-107">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-108">
          <a href="#" className="block group" aria-label="CRECEELITE - Inicio" data-id="element-109">
            <span className="font-montserrat font-extrabold tracking-[0.18em] text-lg md:text-xl neon-text-static" data-id="element-110">
              <span className="text-warmWhite" data-id="element-111">CRECE</span>
              <span className="text-gold" data-id="element-112">ELITE</span>
            </span>
          </a>

          <div className="hidden md:flex items-center space-x-8" data-id="element-113">
            <a href="#pilares" className="font-montserrat text-sm tracking-wide text-warmWhite hover:text-gold transition-colors duration-300" data-id="element-114">
              Los 5 Fundamentos
            </a>
            <a href="#guia" className="font-montserrat text-sm tracking-wide text-warmWhite hover:text-gold transition-colors duration-300" data-id="element-115">
              Guía Gratuita
            </a>
            <a href="#libro" className="font-montserrat text-sm tracking-wide text-warmWhite hover:text-gold transition-colors duration-300" data-id="element-116">
              Ebook
            </a>
          </div>

          <button className="md:hidden text-warmWhite hover:text-gold transition-colors p-2 -mr-2" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-117">
            {isOpen ? <X className="w-6 h-6" data-id="element-118" /> : <Menu className="w-6 h-6" data-id="element-119" />}
          </button>
        </div>
      </motion.nav>

      <AnimatePresence data-id="element-120">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 z-40 bg-richBlack/98 backdrop-blur-xl flex flex-col items-center justify-center space-y-8 md:hidden" data-id="element-121">
            <a href="#pilares" onClick={() => setIsOpen(false)} className="font-montserrat text-2xl tracking-wide text-warmWhite hover:text-gold transition-colors py-4 w-full text-center" data-id="element-122">
              Los 5 Fundamentos
            </a>
            <a href="#guia" onClick={() => setIsOpen(false)} className="font-montserrat text-2xl tracking-wide text-warmWhite hover:text-gold transition-colors py-4 w-full text-center" data-id="element-123">
              Guía Gratuita
            </a>
            <a href="#libro" onClick={() => setIsOpen(false)} className="font-montserrat text-2xl tracking-wide text-warmWhite hover:text-gold transition-colors py-4 w-full text-center" data-id="element-124">
              Ebook
            </a>
          </motion.div>}
      </AnimatePresence>
    </>;
}